@if (showGuidedTours) {
  <div class="guided-tours-container" id="guided-tours">
    <!-- Toggle Button -->
    @if (!showContent) {
      <div class="guided-tours-toggle" (click)="showContent = true" id="guided-tours-show-btn">
        <span class="toggle-title">{{'main.core.guided-tours.management.menu_name' | translate}}</span>
        <i class="fa fa-arrow-left toggle-icon" aria-hidden="true"></i>
      </div>
    }
    <!-- Toggled popup -->
    @if (showContent) {
      <div class="guided-tours-content">
        <div class="guided-tours-content-title">{{'main.core.guided-tours.management.menu_name' | translate}}</div>
        <div class="guided-tours-content-description">{{'main.core.guided-tours.management.menu_description' | translate}}</div>
        <ul class="guided-tours-content-list">
          @for (guide of availableGuides; track guide) {
            <li class="listed-guide" (click)="triggerGuide(guide)">
              {{guide.translatedName}}
            </li>
          }
        </ul>
      </div>
    }
    @if (showContent) {
      <div class="guided-tours-toggle" (click)="showContent = false"  id="guided-tours-hide-btn">
        <span class="toggle-title">{{'main.core.guided-tours.management.minimize' | translate}}</span>
        <i class="fa fa-arrow-right toggle-icon" aria-hidden="true"></i>
      </div>
    }
  </div>
}
